const formatTRT = (duration) => {
    const hrs = Math.floor(duration/3600);
    duration = duration - (hrs * 3600);
    const mins = Math.floor(duration/60);
    duration = duration - (mins * 60);
    const secs = duration;

    return `${hrs}:${mins < 10?'0' + mins:mins}:${secs < 10?'0'+secs:secs}`;
}

export default formatTRT;